<template>
  <span class="yj-breadcrumb__item">
    <span
      :class="['yj-breadcrumb__inner', to ? 'is-link' : '']"
      ref="link"
      role="link">
      <slot></slot>
    </span>
    <i v-if="separatorClass" class="yj-breadcrumb__separator" :class="separatorClass"></i>
    <span v-else class="yj-breadcrumb__separator" role="presentation">{{separator}}</span>
  </span>
</template>
<script>
  export default {
    name: 'YjBreadcrumbItem',
    props: {
      to: {},
      replace: Boolean
    },
    data() {
      return {
        separator: '',
        separatorClass: ''
      };
    },

    inject: ['yjBreadcrumb'],

    mounted() {
      this.separator = this.yjBreadcrumb.separator;
      this.separatorClass = this.yjBreadcrumb.separatorClass;
      const link = this.$refs.link;
      link.setAttribute('role', 'link');
      link.addEventListener('click', _ => {
        const { to, $router } = this;
        if (!to || !$router) return;
        this.replace ? $router.replace(to) : $router.push(to);
      });
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/breadcrumb-item/src/breadcrumb-item.vue